import { Link } from 'react-router-dom'
import { GlassButton } from '@/components/ui/glass-button'

export function NotFoundPage() {
  return (
    <section className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-4 py-32 text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
        404
      </p>
      <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
        That page does not exist
      </h1>
      <p className="max-w-md text-muted-foreground">
        The link may be out of date. Head back to the homepage to find what you were after.
      </p>
      <GlassButton variant="primary" asChild>
        <Link to="/">Back to homepage</Link>
      </GlassButton>
    </section>
  )
}
